import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { OrganizationKeys } from './organization.keys';

interface UploadLogoResponse {
  s3Key: string;
}

export const uploadOrganizationLogo = async (
  organizationId: string,
  logoFile: File,
): Promise<UploadLogoResponse> => {
  const formData = new FormData();
  formData.append('logoFile', logoFile, logoFile.name);

  const response = await clients.admin.post(`/organizations/${organizationId}/logo`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export function useUploadOrganizationLogo(
  organizationId: string,
  options?: UseMutationOptions<UploadLogoResponse, AxiosError, File>,
) {
  const queryClient = useQueryClient();

  return useMutation((logoFile: File) => uploadOrganizationLogo(organizationId, logoFile), {
    onSuccess: () => {
      queryClient.invalidateQueries(OrganizationKeys.detail(organizationId));
    },
    ...options,
  });
}
